export default "/_next/static/images/6a8fb3a3e2de4a2b97cf8793b8fa66d1.jpg";